import * as yup from 'yup';
import { ERegExpTypes } from 'constants/RegExpTypes';
import { useTranslations } from 'hooks/useTranslations';

export const useSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    authCode: yup
      .string()
      .required(t('login.authenticator.enter2FACode.text'))
      .matches(
        new RegExp(ERegExpTypes['4digits']),
        t('login.authenticator.enterCodeIncorrect.text'),
      ),
  });
  return { schema };
};
